export const company = {
  name: "Anushma LLC",
  shortName: "Anushma",
  tagline: "High-Quality Lab Materials for Every Need",
  subtitle:
    "A trusted lab materials distributor based in Dublin, CA — delivering reliable reagents, consumables, and fluidic connections with quality you can trust.",
  phone: "650-204-0995",
  phoneHref: "tel:+16502040995",
  email: "info@anushma.site",
  emailHref: "mailto:info@anushma.site",
  address: "Dublin, CA 94568",
};

export const stats = [
  { value: 16, suffix: "+", label: "Catalog SKUs" },
  { value: 48, suffix: "h", label: "Avg. Fulfilment" },
  { value: 99.6, suffix: "%", label: "On-Spec Delivery", decimals: 1 },
  { value: 8, suffix: "+", label: "Brand Partners" },
];

// Exact categories, descriptions, and product imagery sourced from anushma.site
export const categories = [
  {
    id: "essentials",
    title: "Lab Essentials",
    blurb:
      "From various types of gloves and masks to protective wear, we provide lab essentials tailored to your specific requirements.",
    image: "/assets/cat-essentials.jpg",
  },
  {
    id: "consumables",
    title: "Lab Consumables",
    blurb:
      "We provide high-quality lab consumables like microwell plates, pipettes, and other essential items.",
    image: "/assets/cat-consumables.png",
  },
  {
    id: "fluidics",
    title: "Fluidic Connections",
    blurb:
      "We offer a comprehensive line of tubing, connectors, fittings, and flow control devices for high-performance analytical fluidic systems.",
    image: "/assets/cat-fluidics.jpg",
  },
  {
    id: "reagents",
    title: "Reagents",
    blurb:
      "Quality reagents for GC derivatization, ion pairing, diagnostics, and imaging applications.",
    image: "/assets/cat-reagents.jpg",
  },
];

// Exact catalog (Description + Catalog #) as listed on anushma.site
export const catalog = [
  { name: "Automated Roll Heat Sealer (formerly a4S)", sku: "4TI-0065" },
  {
    name: "Universal Peel Heat Seal, Peelable Heat sealing foil with wide material compatibility, 1 roll (610m x 78mm)",
    sku: "4TI-0523",
  },
  { name: "Azenta 4ti-0665-5 Vacuum Cups, front", sku: "P98-755" },
  { name: "Azenta 4ti-0665-6 Vacuum Cups, back", sku: "P98-756" },
  {
    name: "Large and Heavy Equipment Fasteners (Tabletop Anchorage – Max 600 Lbs.) by SAFE-T-PROOF™",
    sku: "STP-202-12",
  },
  {
    name: "Stacked Equipment (HPLC) Fasteners (Tabletop Anchorage – Max 150 Lbs.) by SAFE-T-PROOF™",
    sku: "STP-201-04",
  },
  { name: "Zerostat anti-static instrument", sku: "Z108812" },
  {
    name: "Amber Vial in Lab File, PTFE/Rubber Liner, 24-400 mm Cap, 40 mL Capacity (Pack of 72)",
    sku: "W224605",
  },
  { name: "AIR IN A CAN (12 Cans per case)", sku: "S-6771" },
  { name: "ACETONITRILE OPTIMA LC/MS, Fisher Chemical, Case of 4 × 4L", sku: "A955-4" },
  {
    name: "Regis Technologies Inc GC Reagent, Regis, 3N HCl in n-Butanol (100 mL)",
    sku: "50-442-871",
  },
  { name: "IDEX Health & Science Upchurch Black PEEK Tubing 1/16 × .004 × 5'", sku: "NC0820967" },
  { name: "IDEX Health & Science Upchurch TI FILTR END FITTING .5U 10/PK", sku: "A-428X" },
  {
    name: "BRAND® Filtered Pipette Tips for Pipettes using 200 µl Tips, BrandTech® 10 pk",
    sku: "732732",
  },
  { name: "Ammonium Acetate 1 Per box", sku: "A11450" },
  { name: "2-Propanol – 4 Per case", sku: "A426S-4" },
];

export const features = [
  {
    title: "Curated for the bench",
    body: "Every SKU is selected for analytical labs — no filler, just the consumables your workflow actually runs on.",
  },
  {
    title: "Trusted brand partners",
    body: "Authentic Fisher, IDEX Health & Science, Azenta, Avantik, BrandTech and more — sourced direct so specs match the datasheet.",
  },
  {
    title: "Fast, reliable fulfilment",
    body: "Based in Dublin, CA and built for turnaround. Quotes tailored to your requirements, shipped on schedule.",
  },
];
